import type {Request, Response} from 'express';
import {getViewSubtabList} from '../../../api/view/getViewSubtabList';
import {getSerializedPagewebError} from '../../../errors/getSerializedPagewebError.function';
import {createSubtabMenu} from '../../../graphql/factory/SubtabMenu';
import {AppStore} from '../../../state/store';
import {MenuState} from '../type';
import {setMenu} from './MenuSlice';

export async function getMenuFromStore({
  store,
  req,
  res,
}: {
  store: AppStore;
  req: Request;
  res: Response;
}): Promise<MenuState['menu']> {
  if (!store.getState().menu.menu.subtabMenuList.length) {
    try {
      const data = await getViewSubtabList({
        req,
        res,
      });
      if (!data) {
        throw new Error('menu data 가 없음');
      }
      store.dispatch(
        setMenu({subtabMenuList: data.menu.map(createSubtabMenu)})
      );
    } catch (error) {
      store.dispatch(
        setMenu({subtabMenuList: [], error: getSerializedPagewebError(error)})
      );
    }
  }
  return store.getState().menu.menu;
}
